import type { SVGProps } from "react";

export const CheckmarkBadgeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}>
    <path
      fill={props.fill || "#059669"}
      d="M9.836 2.034c.112.038.222.084.329.137l1.283.631a1.25 1.25 0 0 0 1.104 0l1.283-.631a2.75 2.75 0 0 1 3.681 1.252l.074.162.063.167.46 1.354c.125.367.414.656.781.78l1.354.46a2.75 2.75 0 0 1 1.581 3.82l-.631 1.282a1.25 1.25 0 0 0 0 1.104l.631 1.283a2.75 2.75 0 0 1-1.581 3.818l-1.354.46a1.25 1.25 0 0 0-.78.781l-.461 1.354a2.75 2.75 0 0 1-3.818 1.581l-1.283-.631a1.25 1.25 0 0 0-1.104 0l-1.283.631a2.75 2.75 0 0 1-3.818-1.581l-.46-1.354a1.25 1.25 0 0 0-.782-.78l-1.353-.46a2.75 2.75 0 0 1-1.582-3.82l.632-1.282a1.25 1.25 0 0 0 0-1.104l-.632-1.283a2.75 2.75 0 0 1 1.582-3.818l1.353-.46a1.25 1.25 0 0 0 .781-.781l.46-1.354a2.75 2.75 0 0 1 3.49-1.718Zm5.633 6.936-5.419 5.419-1.974-2.37a.75.75 0 0 0-1.152.961l2.5 3a.75.75 0 0 0 1.106.05l6-6a.75.75 0 1 0-1.06-1.06Z"
    />
  </svg>
);
